var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8333 24.7905V29.5405C32.8351 29.9814 32.7447 30.4179 32.5681 30.8219C32.3914 31.226 32.1323 31.5887 31.8074 31.8868C31.4825 32.1849 31.0988 32.4118 30.6811 32.5531C30.2634 32.6944 29.8208 32.7468 29.3816 32.7071C24.5094 32.1777 19.8294 30.5129 15.7174 27.8463C11.8918 25.4154 8.64838 22.1719 6.21744 18.3463C3.54157 14.2157 1.87632 9.51289 1.3566 4.61881C1.31703 4.18097 1.36907 3.73968 1.50939 3.32305C1.64972 2.90642 1.87526 2.52357 2.17165 2.19888C2.46804 1.87419 2.82879 1.61477 3.23094 1.43714C3.63308 1.25951 4.06781 1.16756 4.50744 1.16715H9.25744C10.0258 1.15958 10.7708 1.43169 11.3534 1.93274C11.936 2.43379 12.3166 3.1296 12.4241 3.89048C12.6246 5.41058 12.9964 6.90313 13.5324 8.33965C13.7455 8.90636 13.7916 9.52226 13.6653 10.1144C13.539 10.7065 13.2456 11.25 12.8199 11.6805L10.8091 13.6913C13.0631 17.6553 16.3452 20.9374 20.3091 23.1913L22.3199 21.1805C22.7504 20.7548 23.2939 20.4614 23.886 20.3351C24.4782 20.2088 25.0941 20.255 25.6608 20.468C27.0973 21.004 28.5898 21.3758 30.1099 21.5763C30.8791 21.6848 31.5815 22.0722 32.0836 22.6648C32.5857 23.2575 32.8525 24.014 32.8333 24.7905Z",
    stroke: "#FF0F0F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneImg);
export default __webpack_public_path__ + "static/media/phoneImg.4b5147ed8a3be3c025144b3e421ebc1c.svg";
export { ForwardRef as ReactComponent };